import { IconButton } from '@/components';
import { Input } from 'antd';
import type { FC } from 'react';
import { useContext, useState } from 'react';
import { readonlyContext } from '../../../context';
import type { ITableTitleEditorProps } from './type';
import { usePrevious } from 'ahooks';

export const TableTitleEditor: FC<ITableTitleEditorProps> = (props) => {
  // props
  const { value, onRemove, open, onOpenValueChange, ...inputProps } = props;
  // state
  const [editing, setEditing] = useState(false);
  const prevValue = usePrevious(value);
  // context
  const readonly = useContext(readonlyContext);
  const editable = !readonly;
  // methods
  const createTableName = () => {
    const nameJSX = (
      <p className="max-w-[32em]  truncate text-sm font-medium text-main">
        {value as string}
      </p>
    );

    if (readonly) {
      return nameJSX;
    }

    if (editing) {
      return (
        <Input
          className="w-[240px]"
          {...inputProps}
          autoFocus
          value={value}
          maxLength={32}
          onBlur={() => {
            // if (value?.toString().trim().length === 0)
            //   inputProps.onChange?.(prevValue as any);
            setEditing(false);
          }}
        />
      );
    }

    return (
      <div className="min-w-[20px] flex gap-1 items-center group">
        {nameJSX}
        <IconButton
          circle
          title="编辑"
          className="hidden text-secondary-2 hover:text-primary group-hover:flex"
          iconType="icon-gaixie"
          onClick={() => setEditing(true)}
        />
      </div>
    );
  };

  return (
    <section className="flex justify-between items-center h-12">
      <div className="flex gap-1 items-center">
        <IconButton
          className="text-secondary-2 hover:text-secondary-1"
          iconType={open ? 'icon-xiangxia' : 'icon-xiangyou'}
          onClick={() => onOpenValueChange(!open)}
        />
        <section className="flex gap-1 items-center">
          {createTableName()}
        </section>
      </div>
      {editable && (
        <IconButton
          circle
          title="删除"
          className="text-secondary-1 hover:text-error"
          iconType="icon-shanchu1"
          onClick={onRemove}
        />
      )}
    </section>
  );
};
